/* jshint multistr:true */

require('../lib/royalslider/dev/jquery.royalslider.js')

$(function () {
    var rs24;

    function getVideoType(file_url) {
        const videoProviderMap = {
            'vimeo': 'vimeo',
            'youtube': 'youtube',
            'youtu.be': 'youtube',
        };

        let videoProvider = Object.keys(videoProviderMap).filter(key => file_url.includes(key)).toString();

        return videoProviderMap[videoProvider] || 'CDN';
    };

    jwplayer.key='g1st/18c6koHgHREMSYddDH3sd3cb7eWu8V+4Q==';

    function startSlider() {

        // Pozicija bannera
        const $banner = ($(document).width() >= 1200) ? '.js_bannerContainer' : '.dfp_banner';
        $($banner).remove();

        const startIndex = $('.gallery__slider_item.is_current').index();
        let historyEnabled = $('.js_royal').data('history');

        if (!historyEnabled) historyEnabled = false;

        rs24 = $('.js_royal').royalSlider({
            addActiveClass: true,
            autoScaleSlider:false,
            autoHeight: false,
            arrowsNav: false,
            arrowsNavAutoHide: false,
            navigateByClick: false,
            fadeinLoadedSlide: true,
            imageScaleMode: 'fit-if-smaller',
            imageAlignCenter: true,
            imageScalePadding: 0,
            loop: false,
            loopRewind: false,
            controlNavigationSpacing: 0,
            controlNavigation: 'thumbnails',
            numImagesToPreload: 1,
            keyboardNavEnabled: true,
            usePreloader: true,
            startSlideId: startIndex,
            thumbs: {
                arrows: false,
                autoCenter: false,
                fitInViewport: false,
            },
            deeplinking: {
                enabled: false,
                // change: true, // using historyOptions
                prefix: 'slider-'
            },
            historyOptions: {
                enabled: historyEnabled,
                baseUri: window.location.pathname.split('/multimedia/p')[0],
                dataAttr: { // customize them when needed
                    uri: 'history-uri',
                    title: 'history-title',
                    data: 'history-data'
                },
                title: {
                    prefix: ' - ',
                    keepOriginal: true
                },
                callbacks: {
                    stateChange: function(state) {
                        const urlPage = state.cleanUrl
                            .split('page=')
                            .pop()
                            .match(/\d+/);
                        const currentPage = urlPage ? parseInt(urlPage.input, 10) : null;

                        if (currentPage && currentPage === 1) rs24.goTo(0);
                    }
                }
            },

            video: {
                autoHideBlocks: true,
                autoHideArrows: false
            }

        }).data('royalSlider');

        $('.no_royal').removeClass('no_royal');
        $('.royalSlider').css('visibility', 'visible');

        if ( jQuery('.gallery').data('galtype') == 'modal' ) {
            setTimeout(function(){
                rs24.playVideo();
            }, 500);
        }

        rs24.ev.on('rsOnCreateVideoElement', function(e, url) {
            if ( getVideoType( url ) !== 'CDN' ) return;

            // url - path to video from data-rsVideo attribute
            // rs24.videoObj - jQuery object that holds video HTML code
            // rs24.videoObj must be IFRAME, VIDEO or EMBED element, or have class rsVideoObj
            rs24.videoObj = $('<div id="CDNvideo" class="rsVideoObj">Loading the player ...</div>');

            setTimeout(function() {
                jwplayer('CDNvideo').setup({
                    width: '100%',
                    file: url,
                    aspectratio: '4:3',
                    skin: 'glow',  // beelden, bekle, five, glow, modieus, roundster, six, stormtrooper, vapor
                    autostart: true,
                    ga: {},
                    advertising: {
                        client: 'vast',
                        tag: '',
                        admessage: 'Nastavak videa za XX sekundi.',
                        skipoffset: '10',
                        skipmessage: 'Skip in xx s',
                        skiptext: 'Skip'
                    }
                });
            }, 200);
        });

        function setButtons () {

            var currentSlide = rs24.currSlideId;

            if ( currentSlide === 0 ) $('#slider-prev').addClass('is_hidden');
            else $('#slider-prev').removeClass('is_hidden');

            if ( currentSlide == ( rs24.numSlides - 1 ) ) $('#slider-next').addClass('is_hidden');
            else $('#slider-next').removeClass('is_hidden');

            $('.js_galleryCurrent').text( currentSlide + 1 );

            const galleryShare = $('.js_galleryShare');

            if (galleryShare.length) {
                galleryShare.each(function(i, el) {
                    const elHref = el.href.split('page=')[0];

                    if (el.href.indexOf('facebook') != -1) el.href = `${elHref}page=${currentSlide + 1}`;

                    if (el.href.indexOf('twitter') != -1) el.href = `${elHref}page=${currentSlide + 1}&hashtags=zurnal24`;
                });
            }
        }

        setButtons();

        rs24.ev.on('rsAfterSlideChange', function() {

            setButtons();

            // HINT: Disabled because pp_gemius_hit function doesn't exist! Console throws errors.
            // pp_gemius_hit ('zDDg9Hi2P8xVN8R3jRO6o_UT74EFrGeTEJGhA4EBOrD.l7');
        });

        $('.gallery').on('click', '#slider-prev', function(e) {
            e.preventDefault();
            rs24.prev();
        });

        $('.gallery').on('click', '#slider-next', function(e) {
            e.preventDefault();
            rs24.next();
        });
    }

    $(window).on('resize', function(){
        $('.js_royal').royalSlider('updateSliderSize', true);
    });

    function initInlineGallery (){
        let $closeButton = $('.js_closeGallery');
        let $closeUrl = $closeButton.attr('data-close-url');

        if (!document.referrer.includes(window.location.hostname)) $closeButton.attr('href', $closeUrl);

        if ( $('.js_royal').length ) {
            startSlider ();

            $(document).on('keyup', function(e) {
                if (e.key === 'Escape') window.location.href = $closeButton.attr('href');
            });
        }
    }

    initInlineGallery();

});
